/**
 * 애플리케이션 버전 정보
 * 이 파일에서 버전을 중앙 관리합니다.
 */
export const APP_VERSION = '3.2.6';
